/**
 * Available Order Type Names
 */
export enum OrderTypeNameEnum {
  DELIVERY = 'Delivery',
  COLLECTION = 'Collection',
  TABLE = 'Table',
  KERB = 'Kerbside'
}

/**
 * Available Order Types Name indexes in the database.
 */
export enum OrderTypeIndexEnum {
  DELIVERY = 1,
  COLLECTION = 2,
  TABLE = 3,
  KERB = 4
}
